import { FunctionComponent } from 'react';
import { twMerge } from 'src/utils/twMerge';

import styles from 'src/designSystem/SunburstRays.module.scss';

export type SunburstSkin =
  | 'result'
  | 'streakPurple'
  | 'streakGold'
  | 'badge'
  | 'streakHero'
  | 'streakHeroGold';

type Props = {
  skin: SunburstSkin;
  isSpinning?: boolean;
  className?: string;
  'data-testid'?: string;
};

const SunburstRays: FunctionComponent<Props> = ({
  skin,
  isSpinning = false,
  className,
  'data-testid': dataTestId,
}) => (
  <div
    aria-hidden="true"
    data-testid={dataTestId}
    data-spinning={isSpinning}
    className={twMerge(
      'pointer-events-none',
      styles[skin],
      isSpinning && 'animate-badge-rays-spin motion-reduce:animate-none',
      className,
    )}
  />
);

export default SunburstRays;
